const EVENTS: { [key: string]: string } = Object.freeze({
  MA_CRE_CPM_NOTIFICATION_RECEIVED: 'MA_CRE_CPM_NOTIFICATION_RECEIVED',
  MA_CRE_CPM_NOTIFICATION_READ: 'MA_CRE_CPM_NOTIFICATION_READ',
});

export default EVENTS;
